import { render, staticRenderFns } from "./TabStockInventory.vue?vue&type=template&id=57249946&scoped=true&"
import script from "./TabStockInventory.vue?vue&type=script&lang=js&"
export * from "./TabStockInventory.vue?vue&type=script&lang=js&"
import style0 from "./TabStockInventory.vue?vue&type=style&index=0&id=57249946&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57249946",
  null
  
)

export default component.exports